import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 24px;
  line-height: 29px;
  font-weight: 400;
  margin: 0;
  color: ${props => props.theme.colors.mainDark};
`;

export const SecondTitle = styled.h2`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  margin-bottom: 5px;
  color: ${props => props.theme.colors.lightDark};
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/title.js